module.exports = __webpack_public_path__ + "static/media/vx64ovkpz9nu98tqdtzn.d5e8dee0.png";